// extracted by mini-css-extract-plugin
export default {"formChoice":"choicePage_formChoice__qSQkz","ButtonWrapper":"choicePage_ButtonWrapper__fracW","buttonChoice":"choicePage_buttonChoice__As46G"};